export const departmentQueryKeys = {
  id: 'id',
  createdAt: 'created_at',
  departmentName: 'department_name',
  departmentCode: 'department_code',
  warehousesCount: 'warehouses_count',
  stateId: 'state_id',
}
